import { createFloatingLabelsPlugin } from "@formkit/addons";
import { de, en, es, fr, it, ja, ko, nl, pt, tr, zh } from "@formkit/i18n";
import { genesisIcons } from "@formkit/icons";
import { autocomplete, createProPlugin, toggle } from "@formkit/pro";
import { generateClasses } from "@formkit/themes";
import { type DefaultConfigOptions, defineFormKitConfig } from "@formkit/vue";
import { addAsteriskPlugin } from "mws-utils";

import formkitTailwindTheme from "./formkitTailwindTheme";

import "@formkit/addons/css/floatingLabels";
import enAdditional from "~~/i18n/formkit/en";
import nlAdditional from "~~/i18n/formkit/nl";
import zhAdditional from "~~/i18n/formkit/zh";

export const formkitConfigObject = {
  plugins: [
    createProPlugin("fk-9089390677", { autocomplete, toggle }),
    addAsteriskPlugin,
    createFloatingLabelsPlugin(),
  ],
  icons: {
    ...genesisIcons,
  },
  config: {
    classes: generateClasses(formkitTailwindTheme),
  },
  locales: {
    en: {
      ui: en.ui,
      validation: {
        ...en.validation,
        ...enAdditional,
      },
    },
    nl: {
      ui: nl.ui,
      validation: {
        ...nl.validation,
        ...nlAdditional,
      },
    },
    zh: {
      ui: zh.ui,
      validation: {
        ...zh.validation,
        ...zhAdditional,
      },
    },
    fr,
    it,
    tr,
    ja,
    es,
    ko,
    de,
    pt,
  },
} satisfies DefaultConfigOptions;

export default defineFormKitConfig(formkitConfigObject);
